<template>
    <div>
        <el-col :span="span">
            <div class="grid-content bg-purple outBox">
                <div class="numTitle">
                    <slot name="numTitle" class="noWrap"></slot>
                    <slot v-if="toolText===''" name="numTitle" class="noWrap"></slot>
                    <slot name="time" class="numTitle noWrap"  v-if="type!=='timeCenter'"></slot>
                </div>
                <div v-if="type==='timeCenter'" class="timeText" >
                    <slot name="time" class="noWrap"></slot>
                </div>
                <div class="bottomBox">
                    <div class="numBox">
                        <div class="innerTitle">酒店数量</div>
                        <div class="flexEndBox ">
                            <span class="indexNum marginRight">
                                {{showDataCom(allData.酒店数.total,'','','hotelNumUnit')}}
                            <!--<slot name="hotelNum" class="noWrap"></slot>-->
                        </span>
                            <span class="unit">
                                 <span v-if="hotelNumUnit">万</span>
                            <span>家</span>
                        </span>
                        </div>
                        <div class="filterBox grayFonts" v-if="showElCom('isIncrement') || showElCom('isBadness')">
                            <div class="flexBox filterItem" v-if="showElCom('isIncrement')">
                                <div class="title">新增：</div>
                                <span class="numWidth">{{showDataCom(allData.酒店数.increment,'','','hotelIncreaseUnit')}}</span>
                                <span v-if="hotelIncreaseUnit">万</span>
                            </div>
                            <div v-if="showElCom('isIncrement')">
                                <div class="flexBox filterItem" :class="[rateTextStyleCom(allData.yearLevel,allData.yearPercent)]">
                                    <div class="title">环比：</div>
                                    <div class="numWidth">{{allData.酒店数.chainPercent}}%</div>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.chainLevel,allData.酒店数.chainPercent)==='redFonts'">&#xe633;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.chainLevel,allData.酒店数.chainPercent)==='greenFonts'">&#xe631;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.chainLevel,allData.酒店数.chainPercent)==='grayFonts'">-</i>
                                </div>
                                <div class="flexBox filterItem" :class="[rateTextStyleCom(allData.yearLevel,allData.yearPercent)]">
                                    <div class="title">同比：</div>
                                    <div class="numWidth">{{allData.酒店数.yearPercent}}%</div>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.yearLevel,allData.酒店数.yearPercent)==='redFonts'">&#xe633;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.yearLevel,allData.酒店数.yearPercent)==='greenFonts'">&#xe631;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.yearLevel,allData.酒店数.yearPercent)==='grayFonts'">-</i>
                                </div>
                            </div>
                            <div class="flexBox filterItem" v-if="showElCom('isBadness')">
                                <div class="title">不良：</div>
                                <span></span>
                            </div>
                            <div v-if="showElCom('isBadness')">
                                <div class="flexBox filterItem">
                                    <div class="title">0%：</div>
                                    <div slot="badnessZero" class="numWidth">{{showDataCom(allData.酒店数.badnessZero,'','','hotelBadZeroUnit')}}</div>
                                    <i class="iconfont hideEl">-</i>
                                    <span v-if="hotelBadZeroUnit">万</span>
                                </div>
                                <div class="flexBox filterItem">
                                    <div class="title">1%-30%：</div>
                                    <div slot="badnessThirty" class="numWidth">{{showDataCom(allData.酒店数.badnessThirty,'','','hotelBadThirtyUnit')}}</div>
                                    <span v-if="hotelBadThirtyUnit">万</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="numBox">
                        <div class="innerTitle">终端数量</div>
                        <div class="flexEndBox ">
                            <span class="indexNum marginRight">
                            {{showDataCom(allData.终端数.total,'','','terNumUnit')}}
                        </span>
                            <span class="unit">
                                <span v-if="terNumUnit">万</span>
                                 <span>台</span>
                            </span>
                        </div>
                        <div class="filterBox grayFonts" v-if="showElCom('isIncrement') || showElCom('isBadness')">
                            <div class="flexBox filterItem" v-if="showElCom('isIncrement')">
                                <div class="title">新增：</div>
                                <span slot="increment">{{showDataCom(allData.终端数.increment,'','','terIncreaseUnit')}}</span>
                                <span v-if="terIncreaseUnit">万</span>
                            </div>
                            <div v-if="showElCom('isIncrement')">
                                <div class="flexBox filterItem" :class="[rateTextStyleCom(allData.终端数.chainLevel,allData.终端数.chainPercent)]">
                                    <div class="title">环比：</div>
                                    <div slot="chainPercent" class="numWidth">{{allData.终端数.chainPercent}}%</div>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.终端数.chainLevel,allData.终端数.chainPercent)==='redFonts'">&#xe633;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.终端数.chainLevel,allData.终端数.chainPercent)==='greenFonts'">&#xe631;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.chainLevel,allData.酒店数.chainPercent)==='grayFonts'">-</i>
                                </div>
                                <div class="flexBox filterItem" :class="[rateTextStyleCom(allData.终端数.yearLevel,allData.终端数.yearPercent)]">
                                    <div class="title">同比：</div>
                                    <div slot="yearPercent" class="numWidth">{{allData.终端数.yearPercent}}%</div>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.终端数.yearLevel,allData.终端数.yearPercent)==='redFonts'">&#xe633;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.终端数.yearLevel,allData.终端数.yearPercent)==='greenFonts'">&#xe631;</i>
                                    <i class="iconfont" v-if="rateTextStyleCom(allData.酒店数.yearLevel,allData.酒店数.yearPercent)==='grayFonts'">-</i>
                                </div>
                            </div>
                            <div class="flexBox filterItem" v-if="showElCom('isBadness')">
                                <div class="title">不良：</div>
                                <span slot="increment"></span>
                            </div>
                            <div v-if="showElCom('isBadness')">
                                <div class="flexBox filterItem">
                                    <div class="title">0%：</div>
                                    <div slot="badnessZero" class="numWidth">{{showDataCom(allData.终端数.badnessZero,'','','terBadZeroUnit')}}</div>
                                    <i class="iconfont hideEl">-</i>
                                    <span v-if="terBadZeroUnit">万</span>
                                </div>
                                <div class="flexBox filterItem">
                                    <div class="title">1%-30%：</div>
                                    <div slot="badnessThirty" class="numWidth">{{showDataCom(allData.终端数.badnessThirty,'','','terBadThirtyUnit')}}</div>
                                    <span v-if="terBadThirtyUnit">万</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </el-col>
    </div>
</template>

<script>
    // greenColor orangeColor blueColor   redColor
    export default {
        name: "QuarterRow",
        props:{
            span:{
                default:6
            },
            toolText:{
                default:''
            },
            type:{
                default:'timeRight'
            },
            color:{},
            iconShow:{
                default:false
            },
            parShowDate:{},
            parShowUnit:{},
            filterGroup:{},
            allData:{
                type:Object,
                default:function(){
                    return {
                        终端数:{
                            badnessThirty: 11,
                            badnessZero: 11,
                            chainLevel: 1,
                            chainPercent:"0.00",
                            increment: "0",
                            total: "0",
                            yearLevel: 1,
                            yearPercent: "0.00",
                        },
                        酒店数:{
                            badnessThirty: 111,
                            badnessZero: 11,
                            chainLevel: 1,
                            chainPercent:"0.00",
                            increment: "0",
                            total: "0",
                            yearLevel: 1,
                            yearPercent: "0.00",
                        }
                    }
                }
            },
        },
        data: () => ({
            isShowHotelUnit:false,
            hotelNumUnit:false,
            hotelIncreaseUnit:false,
            hotelBadZeroUnit:false,
            hotelBadThirtyUnit:false,
            terNumUnit:false,
            terIncreaseUnit:false,
            terBadZeroUnit:false,
            terBadThirtyUnit:false,
        }),
        methods:{
            modelTypeUnit(type,val){
                switch(type){
                    case 'hotelNum':
                        this.hotelNumUnit=val;
                        break;
                    case 'hotelIncrease':
                        this.hotelIncreaseUnit=val;
                        break;
                    case 'hotelBadZero':
                        this.hotelBadZeroUnit=val;
                        break;
                    case 'hotelBadThirty':
                        this.hotelBadThirtyUnit=val;
                        break;
                    case 'terNumUnit':
                        this.terNumUnit=val;
                        break;
                    case 'terIncrease':
                        this.terIncreaseUnit=val;
                        break;
                    case 'terBadZero':
                        this.terBadZeroUnit=val;
                        break;
                    case 'terBadThirty':
                        this.terBadThirtyUnit=val;
                        break;
                }
            }
        },
        mounted(){

        },
        computed:{
            showDataComTest(){
                return function(s,type='',n=2){
                    if(type==='money'){
                        if(s===null){
                            return 0;
                        }else{
                            n = n > 0 && n <= 20 ? n : 2;
                            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                            var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
                            var t = "";
                            for (var i = 0; i < l.length; i++) {
                                t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                            }
                            return t.split("").reverse().join("") + "." + r;
                        }
                    }else{
                        if(s===null){
                            return 0;
                        }else{
                            return parseFloat(s).toLocaleString();
                        }
                    }
                }
            },
            showDataCom(){
                return function(s,type='',n=2,unitType){
                    var stringNum=String(s);
                    var pointIndex=stringNum.indexOf('.');
                    var strLength=0;
                    var result=0;
                    if(pointIndex!==-1){  //有小数点
                        var noPointStr=String(s).substring(0,pointIndex);
                        strLength=noPointStr.length;
                    }else{
                        strLength=stringNum.length;
                    }
                    if(s===null){
                        return 0;
                    }else{
                        if(strLength>5){
                            this.modelTypeUnit(unitType,true);
                            result = Math.floor((s /10000) * 100) / 100; //保留小数点两位
                            return result.toFixed(2);
                            // if(type==='money'){
                            //     result = Math.floor((s /10000) * 100) / 100; //保留小数点两位
                            //     console.log('是金钱',result);
                            //     return result;
                            // }else{
                            //     result = parseInt((s /10000) * 100 / 100); //取整
                            //     return parseFloat(String(result)).toLocaleString();
                            // }
                        }else{   //小于5
                            this.modelTypeUnit(unitType,false);
                            if(type==='money'){
                                n = n > 0 && n <= 20 ? n : 2;
                                s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                                var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
                                var t = "";
                                for (var i = 0; i < l.length; i++) {
                                    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                                }
                                return t.split("").reverse().join("") + "." + r;
                            }else{
                                return parseFloat(s).toLocaleString();
                            }
                        }

                    }
                }
            },
            showElCom(){
                return function(val){
                    var flag=false;
                    if(this.filterGroup){
                        if(this.filterGroup.newIncreaseOrBad.indexOf(val)!==-1){
                            flag=true;
                        }
                    }
                    return flag;
                }
            },
            rateTextStyleCom(){
                return function(level,percent){
                    var color='';
                    if(level && percent){
                        if(level == 1 && percent &&  percent!=0.00){
                            color='redFonts'
                        }else if(level == 1 && percent==0.00){
                            color='grayFonts'
                        }else if(level != 1){
                            color='greenFonts'
                        }
                    }else{
                        color='grayFonts'
                    }
                    return color;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .el-col-5{
        width:20%!important;
    }
    .el-row {
        margin-top: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .borderBox.rowBox .grid-content{
        /*border:1px solid #ddd;*/
    }

    .vertical{
        .grid-content{
            height:100%;
            display:flex;
            flex-direction: column;
            justify-content: space-between;
            .numTitle{
                margin-bottom:20px;
                display:flex;
                justify-content: space-between;
                color:#a3a7af;
            }
            .num{
                font-size:24px;
                margin-right:30px;
            }
        }
        .bg-purple {
            /*background: #d3dce6;*/
            background: #fff;
        }
        .grid-content {
            border-radius: 4px;
            padding:20px 20px;
        }
    }
    .indexIcon{
        font-size:40px;
    }
    .indexIcon.green{
        color:#40c2ad;
    }
    .indexIcon.orange{
        color:#ff9846;
    }
    .indexIcon.blue{
        color:#445eee;
    }
    .indexIcon.red{
        color:#f12525;
    }
    .numBox{
        width:50%;
        /*margin-right:*/
        /*display:flex;*/
        /*align-items: flex-end;*/
    }
    .indexNum.marginRight{
        margin-right:10px;
        font-size: 28px;
    }
    .unit{
        margin-bottom:5px;
        color: #a3a7af;
        font-size: 14px;
    }
    .bottomBox{
        display:flex;
        justify-content: space-between;
    }
    .outBox{
        box-shadow:0 0 11px 2px rgba(94,151,255,0.15);
    }
    .timeText{
        margin-left: -6px;
        margin-bottom:20px;
        font-size:12px;
        color:#a3a7af;
    }
    .noWrap{
        white-space:nowrap!important;
    }
    .pointer{
        cursor:pointer;
    }
    .numUnit{
        font-family: DIN!important;
        font-size:32px;
    }
    .flexBox{
        display:flex;
    }
    .flexEndBox{
        display:flex;
        align-items: flex-end;
    }
    .flexColumnBox{
        display:flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .comment{
        margin-left:10px;
    }
    .marginRight{
        margin-right:10px;
    }
    .filterBox{
        margin-top:20px;
        .title{
            width:48px;
            text-align: left;
            color:#a3a7af!important;
        }
        .filterItem{
            margin-top:10px;
            font-size:14px;
        }
    }
    .grayFonts {
        /*font-family: DIN !important;*/
        color: #939495;
    }
    .innerTitle{
        margin-bottom:10px;
    }
    .redFonts {
        font-family: DIN !important;
        color: rgba(255, 8, 8, 1);
    }
    .greenFonts {
        font-family: DIN !important;
        color: rgba(57, 187, 40, 1);
    }
    .grayFonts {
        font-family: DIN !important;
        color: #939495;
    }
    .marginBottom{
        margin-bottom:20px;
    }
    .numWidth{
        white-space: nowrap;
        margin-right:5px;
    }
    .hideEl{
        visibility: hidden;
    }
</style>
